(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["roaza-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('roaza-motion')) {
  customElements.define('roaza-motion', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { passive: true, signal: this.controller.signal };
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let start = null;
      document.addEventListener('pointerdown', event => {
        start = event.isPrimary && event.button === 0
          ? { id: event.pointerId, x: event.clientX, y: event.clientY, time: performance.now() }
          : null;
      }, options);
      document.addEventListener('pointercancel', () => { start = null; }, options);
      document.addEventListener('scroll', () => { start = null; }, { ...options, capture: true });
      document.addEventListener('pointerup', event => {
        const tap = start;
        start = null;
        if (!tap || tap.id !== event.pointerId || reduced.matches ||
            performance.now() - tap.time > 700 ||
            Math.hypot(event.clientX - tap.x, event.clientY - tap.y) > 12) return;
        if (event.target instanceof Element &&
            event.target.closest('input,textarea,select,[contenteditable="true"],video')) return;
        while (this.childElementCount >= 6) this.firstElementChild.remove();
        const ring = document.createElement('span');
        ring.className = 'rz-tap-ring';
        ring.style.left = event.clientX + 'px';
        ring.style.top = event.clientY + 'px';
        this.append(ring);
        ring.addEventListener('animationend', () => ring.remove(), { once: true });
        window.setTimeout(() => ring.remove(), 600);
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.replaceChildren();
    }
  });
}

if (!window.roazaDynamicMotion) {
  window.roazaDynamicMotion = true;
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const active = new Set();
  const selectors = '.rz-hero-copy > *, .rz-spotlight, .rz-benefits > div, .rz-section-head, .rz-category, .rz-product, .rz-help-section > div, #MainContent product-card, #MainContent .rz-browse a';
  const reveal = element => {
    if (seen.has(element)) return;
    seen.add(element);
    if (preference.matches || window.Shopify?.designMode || !element.animate) return;
    const animation = element.animate(
      [{ opacity: 0.25, translate: '0 18px' }, { opacity: 1, translate: '0 0' }],
      { duration: 550, easing: 'cubic-bezier(.2,.65,.3,1)' }
    );
    active.add(animation);
    animation.finished.then(() => active.delete(animation), () => active.delete(animation));
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      reveal(entry.target);
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08 }) : null;
  const scan = (root = document) => {
    root.querySelectorAll(selectors).forEach(element => {
      if (!seen.has(element)) observer ? observer.observe(element) : seen.add(element);
    });
  };
  preference.addEventListener('change', () => {
    if (preference.matches) active.forEach(animation => animation.cancel());
  });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selectors).forEach(element => observer?.unobserve(element));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
  document.addEventListener('focusin', () => active.forEach(animation => animation.cancel()));
}
  } catch(e) { console.error(e); }
})();

})();
